import { useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { setLoading } from "../store/actions/commonAction";

function Home() {
	const dispatch = useDispatch();

	dispatch(setLoading(false));

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
					<Typography variant="h5">Welcome</Typography>
				</Paper>
			</Grid>
		</Grid>
	);
}

export default Home;
